import actions from './actions';
import mutations from './mutations';

const state = {
	users: [],
	count: 0,
	offset: 0,
	showLength: 10,
	search: '',
	status: undefined,
	sort: undefined,
	loading: false,
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
};
